var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: [_vm.namespace(), _vm.skinStyle] }, [
    _c(
      "button",
      {
        class: _vm.btnClass,
        attrs: { type: "button" },
        on: {
          click: function($event) {
            return _vm.click($event)
          }
        }
      },
      [
        _c("span", { class: _vm.mdsNS("button__text") }, [
          _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
        ]),
        _vm._v(" "),
        _c(
          "svg",
          {
            class: _vm.mdsNS("icon button__icon button__icon--right"),
            attrs: { "aria-hidden": "true" }
          },
          [_c("use", { attrs: { "xlink:href": "#caret-down--s" } })]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }